/*
 *
 *  Filters
 */

// deps
import Vue from 'vue'

// dbg
Vue.filter('dbg', function(value, title) {
  if (!value) return 'No values'
  if (!title) title = ''
  var dbg = JSON.stringify(value, null, 2)
  dbg = '<pre class="dbg"><span class="text-black block mb-1">' + title + '</span>' + dbg + '</pre>'
  return dbg
})
